import { Grid, InputLabel } from '@material-ui/core';

import { Backdrop, InputPassword, NotificationText, PasswordStrength } from '@room-match/shared-ui-components';
import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { IUserChangePasswordRequestPayload } from 'shared/interfaces/IUser';
import { authService } from 'shared/services/authService';
import { getErrorMessage } from 'shared/utils/room-shared';

import { FlexContainer, MainCont, PasswordStrengthContainer, Row, SaveButton } from './ChangePassword.styles';
import ChangePasswordForm from './ChangePasswordForm';

const { changePassword } = authService();

const ChangePassword = () => {
  const queryClient = useQueryClient();
  const [showSuccess, handleShowSuccess] = useState<boolean>(false);
  const [notificationType, setNotificationType] = useState<'fail' | 'success'>('success');

  const { mutate, isLoading } = changePassword();

  const handleSubmitChangePassword = (values: IUserChangePasswordRequestPayload, helper: any) => {
    mutate(
      { payload: values },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(['user'], {
            refetchInactive: true,
          });
          helper.resetForm();
          setNotificationType('success');
          handleShowSuccess(true);
        },
        onError: (errors) => {
          if (errors.response) {
            setNotificationType('fail');
            handleShowSuccess(true);
          }
        },
      },
    );
  };

  const { form } = ChangePasswordForm({ onSubmit: handleSubmitChangePassword });

  return (
    <MainCont>
      <Grid item style={{ marginBottom: 15 }}>
        <p style={{ fontSize: 25 }}>Change Password</p>
      </Grid>
      <Row>
        <Grid item>
          <Grid item>
            <InputLabel>Current Password</InputLabel>
            <InputPassword
              fullWidth
              errorMessage={getErrorMessage(form.touched.current_password, form.errors.current_password)}
              name="current_password"
              variant="outlined"
              onChange={form.handleChange}
              onBlur={form.handleBlur}
              value={form.values.current_password}
              placeholder="Enter current password…"
              InputLabelProps={{ shrink: true }}
              inputProps={{ tabIndex: 2 }}
              style={{ marginTop: 10 }}
              onCopy={(e) => {
                e.preventDefault();
                return false;
              }}
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
            />
          </Grid>
          <Grid item style={{ marginTop: 10 }}>
            <InputLabel>New Password</InputLabel>
            <InputPassword
              fullWidth
              errorMessage={getErrorMessage(form.touched.new_password, form.errors.new_password)}
              name="new_password"
              variant="outlined"
              onChange={form.handleChange}
              onBlur={form.handleBlur}
              value={form.values.new_password}
              placeholder="Enter new password…"
              InputLabelProps={{ shrink: true }}
              inputProps={{ tabIndex: 2 }}
              style={{ marginTop: 10 }}
              onCopy={(e) => {
                e.preventDefault();
                return false;
              }}
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
            />
          </Grid>
          <Grid item style={{ marginTop: 10 }}>
            <InputLabel>Confirm New Password</InputLabel>
            <InputPassword
              fullWidth
              errorMessage={getErrorMessage(
                form.touched.new_password_confirmation,
                form.errors.new_password_confirmation,
              )}
              name="new_password_confirmation"
              onChange={form.handleChange}
              onBlur={form.handleBlur}
              value={form.values.new_password_confirmation}
              variant="outlined"
              placeholder="Confirm new password…"
              InputLabelProps={{ shrink: true }}
              inputProps={{ tabIndex: 2 }}
              style={{ marginTop: 10 }}
              onCopy={(e) => {
                e.preventDefault();
                return false;
              }}
              onPaste={(e) => {
                e.preventDefault();
                return false;
              }}
            />
          </Grid>
        </Grid>
        <PasswordStrengthContainer>
          <PasswordStrength password={form.values.new_password} />
        </PasswordStrengthContainer>
      </Row>
      <FlexContainer item>
        <SaveButton
          color="primary"
          variant="contained"
          disableElevation
          onClick={() => form.handleSubmit()}
          disabled={!form.dirty}
        >
          Save Changes
        </SaveButton>
        <NotificationText show={showSuccess} setShow={handleShowSuccess} type={notificationType} />
      </FlexContainer>
      <Backdrop isLoading={isLoading} />
    </MainCont>
  );
};

export default ChangePassword;
